import type { CoinPriceCache } from 'oscar-typedef'
import APIRequest from '../../APIRequest'
import type APIResponse from '../../APIResponse'
import InterfaceAPI from '../../InterfaceAPI'
import type IGlobalAPI from './IGlobalAPI'

class GlobalAPI implements IGlobalAPI {
  private basePath = '/global'
  constructor(private fetcher: InterfaceAPI) {}

  async global(): Promise<CoinPriceCache.Global.Response.Body> {
    const request = new APIRequest({
      url: `${this.basePath}`,
      method: 'GET',
    })
    const res: APIResponse<
      unknown,
      CoinPriceCache.Global.Response.Body,
      typeof request
    > = await this.fetcher.send(request)
    return res.data
  }
}

export default GlobalAPI
